import React from "react";
import { Box, Typography } from "@mui/material";
import RiskGaugeChart from "components/riskScore/riskGaugeChart";

const ScoreComparison = ({
  originalScore,
  aiScore,
  maxValue = 3,
  showOriginal = true,
  isIcd = false,
}) => {
  return (
    <Box
      display="flex"
      gap={4}
      justifyContent="center"
      alignItems="center"
      p={2}
      sx={{ backgroundColor: "#f5f7fa", borderRadius: 1 }}
    >
      {showOriginal && (
        <Box>
          <RiskGaugeChart
            value={parseFloat(originalScore)}
            showTittle={false}
            bgColor="#f5f7fa"
            maxValue={maxValue}
          />
          <Typography textAlign="center" mt={1}>
            Original Score
          </Typography>
        </Box>
      )}
      <Box>
        <RiskGaugeChart
          value={parseFloat(aiScore)}
          showTittle={false}
          bgColor="#f5f7fa"
          maxValue={maxValue}
        />
        <Typography textAlign="center" mt={1}>
          AI Score {!showOriginal && isIcd ? "ICD" : "CPT"}
        </Typography>
      </Box>
    </Box>
  );
};

export default ScoreComparison;
